export const PROPERTY_VIEW_EMPTY = '—'

export function fmtDate(value?: string | number | Date | null): string {
  if (!value) return PROPERTY_VIEW_EMPTY
  const d = new Date(value)
  return isNaN(d.getTime()) ? PROPERTY_VIEW_EMPTY : d.toLocaleDateString()
}

export function fmtDateTime(value?: string | number | Date | null): string {
  if (!value) return PROPERTY_VIEW_EMPTY
  const d = new Date(value)
  return isNaN(d.getTime()) ? PROPERTY_VIEW_EMPTY : d.toLocaleString()
}

export function fmtCurrency(value?: number | null, currency?: string): string {
  if (value == null) return PROPERTY_VIEW_EMPTY
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD',
      maximumFractionDigits: 2,
    }).format(value)
  } catch {
    return `${value.toLocaleString()} ${currency || ''}`.trim()
  }
}

/** Field keys whose numeric values represent a duration in minutes. */
export function isDurationMinutesField(key: string): boolean {
  const normalized = key.replace(/_/g, '').toLowerCase()
  return normalized.endsWith('durationminutes')
}

/** Format minutes as hours:minutes (e.g. 150 → "2:30", 45 → "0:45"). */
export function formatDurationMinutesAsHm(minutes: number | null | undefined): string {
  if (minutes == null || Number.isNaN(Number(minutes))) {
    return PROPERTY_VIEW_EMPTY
  }
  const total = Math.max(0, Math.round(Number(minutes)))
  const hours = Math.floor(total / 60)
  const mins = total % 60
  return `${hours}:${String(mins).padStart(2, '0')}`
}
